import { render, staticRenderFns } from "./UniPromotionTaskDetail.vue?vue&type=template&id=ca74b212&scoped=true"
import script from "./UniPromotionTaskDetail.vue?vue&type=script&lang=js"
export * from "./UniPromotionTaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca74b212",
  null
  
)

export default component.exports